<template>
  <div class="bottomLan flex_row_center">
    <div class="main flex_row_between" style="width: 100%;">
      <b-container>
        <b-row>
          <b-col sm="3">
            <div class="bottom-left flex_column_center">
              <img
                :src="pictureBaseUrl + '/main/logo1.png'"
                alt
                class="bottom-left-img"
              />
              <!-- <div class="bottom-left-title">宁波歌珊</div> -->
            </div>
          </b-col>
          <b-col sm="9">
            <div class="bottom-right">
              <div class="bottom-right-top flex_row_around">
                <div
                  v-for="item in titleTab"
                  :key="item.name"
                  class="bottom-right-top-item"
                >
                  <a @click="scrollTo(item)" class="title-right-item-a">
                    {{ item.name }}</a
                  >
                </div>
              </div>
              <div>
                <b-container>
                  <b-row style="font-size: 14px;">
                    <b-col sm="6">
                      <div
                        style="font-size: 1.8em;font-weight: 600;margin:10px 0;"
                      >
                        联系电话：15867592348
                      </div>
                      <div
                        style="font-size: 1.0em;font-weight: 600;margin:10px 0;"
                      >
                        公司地址：宁波市鄞州区宁南北路808号慧和大厦1816A
                      </div>
                      <div>
                        <a href="http://beian.miit.gov.cn/"
                          >浙ICP备20011259号</a
                        >
                      </div>
                    </b-col>
                    <b-col sm="6">
                      <b-row class="bottom-right-img">
                        <b-col sm="6" class="flex_column_center">
                          <img
                            :src="pictureBaseUrl + '/main/底部二维码更换.jpg'"
                            alt
                          />
                          <div style="margin-top: 10px;">关注公众号</div>
                        </b-col>
                        <b-col sm="6" class="flex_column_center">
                          <img
                            :src="pictureBaseUrl + '/main/个人二维码.jpg'"
                            alt
                          />
                          <div style="margin-top: 10px;">扫码咨询老师</div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-container>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <!-- <b-container >
        <b-row>
          <b-col sm="3" class="bottom-left">
            <img :src="pictureBaseUrl+'/9_erweima@2x.png'" alt />
          </b-col>
          <b-col sm="9" class="bottom-right">
            <div style="display:flex;padding-top: 20px" class="bottom-line">
              <div style="width:125px;">友情链接：</div>
              <div>
                <a href="https://pro.learning.gov.cn/">浙江专业技术人员学习新干线</a> &nbsp;&nbsp;&nbsp;
                <a style href="http://hzzcpd.zjhz.hrss.gov.cn/">杭州市职称系统</a>&nbsp;&nbsp;&nbsp;
                <a
                  href="http://www.zjzwfw.gov.cn/zjservice/front/index/page.do?webId=1"
                >浙江政务网</a>&nbsp;&nbsp;&nbsp;
                <a href="http://www.zjhrss.gov.cn/">浙江人社局</a>
              </div>
            </div>
            <div style="display:flex; padding-top: 20px">
              <div style="width:115px;">联系我们：</div>
              <div>
                <div class="bottom-logo">
                  <img :src="pictureBaseUrl+'/9_dainhua_icon@2x.png'" alt />
                  <div>电话：158-6759-2348</div>
                </div>
                <div class="bottom-logo" style="padding-top: 20px">
                  <img :src="pictureBaseUrl+'/9_weizhi_icon@2x.png'" alt />
                  <div>地址：浙江省宁波市海曙区解放南路15号仓基大厦5827室</div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container> -->
  </div>
</template>

<script>
var global = require("@/utils/global");

export default {
  name: "topGrey",
  data() {
    return {
      msg: "topGrey",
      pictureBaseUrl: global.pictureBaseUrl,
      titleTab: [
        { name: "首页", enName: "HOME", fouced: false, link: "home" },
        { name: "服务流程", enName: "SERVICE", fouced: false, link: "service" },
        { name: "服务案例", enName: "CASES", fouced: false, link: "guarantee" },
        { name: "关于我们", enName: "ABOUT US", fouced: false, link: "about" },
      ],
    };
  },
  methods: {
    scrollTo(item) {
      const section = document.getElementById(item.link);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bottomLan {
  margin-top: 40px;
  background-color: rgb(24, 75, 149, 1);

  width: 100%;
  color: #fff;
  /* padding: 20px 0; */
}
.bottom-left {
  background-color: rgb(24, 75, 149, 1);
  height: 100%;
}
.bottom-right {
  padding: 20px 0;
  font-size: 1.2em;
}

.bottom-left-title {
  font-size: 2em;
}
.bottom-right-top {
  border-bottom: 1px solid;
  padding-bottom: 8px;
  margin-bottom: 8px;
}
.bottom-right-img img {
  width: 6vw;
  height: 6vw;
}
a:hover {
  text-decoration: none;
  color: rgba(30, 80, 174, 1);
}
.bottom-logo {
  display: flex;
}
.bottom-logo img {
  width: 15px;
  height: 16px;
  margin-right: 5px;
  margin-top: 2px;
}
/* 响应式 */
@media screen and (max-width: 780px) {
  .bottom-line {
    margin-top: 20px;
  }
  .bottom-img {
    display: flex;
    justify-content: center;
  }
  .bottom-right-img img {
    width: 60%;
    height: auto;
  }
}
.bottom-left-img {
  width: 300px;
}
a {
  color: #fff;
}
a:hover {
  color: #fff;
}
@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/bottomLan.vue